module.exports = __webpack_public_path__ + "static/media/plus-circle-white.7d207584.svg";